import api from "../api";
import {
  ICreateTemplate,
  ICustomerTemplate,
  IKeywords,
  IKeywordsHearingFile,
} from "./interface";

export const customerTemplateService = {
  getAllByCustomerId: async ({
    customerId,
    active,
    type,
    pageNumber,
    pageSize,
    searchTerm,
  }: ICustomerTemplate) => {
    try {
      const queryParams = new URLSearchParams();

      if (customerId !== undefined) {
        queryParams.append("customerId", String(customerId));
      }
      if (active !== null && active !== undefined) {
        queryParams.append("active", String(active));
      }
      if (type !== null && type !== undefined) {
        queryParams.append("type", String(type));
      }
      if (pageNumber !== undefined) {
        queryParams.append("pageNumber", String(pageNumber));
      }
      if (pageSize !== undefined) {
        queryParams.append("pageSize", String(pageSize));
      }
      if (searchTerm) {
        queryParams.append("searchTerm", searchTerm);
      }

      const { data } = await api.get(
        `/v1/CustomerTemplate/GetAllByCustomerId?${queryParams.toString()}`,
      );
      return {
        success: true,
        message: "",
        body: data.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message,
        body: null,
      };
    }
  },
  createTemplate: async (params: ICreateTemplate) => {
    try {
      const { data } = await api.post("/v1/CustomerTemplate/Add", params);

      return {
        success: true,
        body: data,
        message: data.message,
      };
    } catch (error: any) {
      const messages = error?.response?.data?.errors;
      return {
        success: false,
        body: {},
        message:
          error?.response?.data.message || Array.isArray(messages)
            ? messages?.at(0)?.message
            : "An unexpected error occurred",
      };
    }
  },
  updateTemplate: async (param: ICreateTemplate) => {
    try {
      const { data } = await api.put("/v1/CustomerTemplate/Update", param);

      return {
        success: true,
        body: data.data,
        message: data?.message,
      };
    } catch (error: any) {
      return {
        success: false,
        body: {},
        message: error?.response?.data?.message,
      };
    }
  },
  SetKeywords: async ({ hearingId, customerTemplateId }: IKeywords) => {
    try {
      const { data } = await api.get(
        `/v1/CustomerTemplate/SetKeywords?hearingId=${hearingId}&customerTemplateId=${customerTemplateId}`,
      );

      return {
        success: true,
        body: data.data,
        message: "",
      };
    } catch (error: any) {
      return {
        success: false,
        body: {},
        message: error?.response?.data?.message,
      };
    }
  },
  SetKeywordsByHearingFile: async ({
    hearingFileId,
    customerTemplateId,
  }: IKeywordsHearingFile) => {
    try {
      const { data } = await api.get(
        `/v1/CustomerTemplate/SetKeywords?hearingFileId=${hearingFileId}&customerTemplateId=${customerTemplateId}`,
      );

      return {
        success: true,
        body: data.data,
        message: "",
      };
    } catch (error: any) {
      return {
        success: false,
        body: {},
        message: error?.response?.data?.message,
      };
    }
  },
};
